<template>
  <dropdown class="event-options">
    <span slot="trigger"
      class="glyphicon glyphicon-option-horizontal clickable options-trigger">
    </span>
    <ul slot="options" class="dropdown-menu show">
      <li>
        <ftp-sync-button></ftp-sync-button>
      </li>
    </ul>
  </dropdown>
</template>

<script>
import FtpSyncButton from '../marker/FTPSyncButton.vue'
import Dropdown from '../generic/Dropdown.vue'

export default {
  components: {
    FtpSyncButton,
    Dropdown
  }
}
</script>
